import { THEME } from '@Theme';
import { StyleSheet } from 'aphrodite';
import { BrowserMediaQueries, CssSelectors } from '../../../styles/styles';

const {
	spacing,
	colors,
	common: { border, borderRadius },
	typography: { fontSizes, fontWeights },
} = THEME;

/** Height of the fixed footer (OK/Cancel buttons + separator + padding) */
const FIXED_FOOTER_HEIGHT = 130;

export const styleSheet = StyleSheet.create({
	drawerContainer: {
		backgroundColor: colors.background.light,
		height: '100%',
		padding: spacing.lg,
		width: '100%',
		gap: spacing.md,
	},
	drawerContainerWithFooter: {
		paddingBottom: FIXED_FOOTER_HEIGHT,
	},
	divider: {
		borderBottom: border,
	},
	legend: {
		margin: spacing.none,
		width: '100%',
	},
	fieldset: {
		border: 'none',
		padding: 0,
	},
	row: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
	},
	collapseTrigger: {
		color: colors.text.dark,
		fontSize: fontSizes.lg,
		width: '100%',
		justifyContent: 'space-between',
		paddingRight: spacing.xs,
	},
	paddingBottomMd: {
		paddingBottom: spacing.md,
	},
	closed: {
		transform: 'rotate(90deg)',
	},
	open: {
		transform: 'rotate(-90deg)',
	},
	hide: {
		display: 'none',
	},
	statusFilters: {
		marginTop: spacing.sm + 2,
		marginBottom: spacing.xs + 1,
	},
});

export const compoundFiltersStyles = StyleSheet.create({
	tagListBuilderContainer: {
		margin: spacing.none,
		background: colors.background.light,
		borderRadius,
		width: 'auto',
		...CssSelectors.allDescendants(
			{
				background: colors.background.light,
			},
			'.autocomplete-search-field-input'
		),
	},
	gap: {
		gap: spacing.sm,
	},
	bold: {
		fontWeight: fontWeights.bold,
	},
	textBase: {
		margin: spacing.none,
	},
	textSm: {
		fontSize: fontSizes.sm,
	},
	textColor: {
		color: colors.text.main,
	},
	policySelectConstraint: {
		...CssSelectors.allDescendants(
			{
				maxWidth: 340,
			},
			'div[class^=multiselect-trigger-container]'
		),
	},
	autoCompleteMenuItem: {
		color: colors.primary.main,
	},
	advancedTagSearch: {
		display: 'flex',
		width: '100%',
		alignItems: 'center',
		cursor: 'pointer',
		marginTop: spacing.xs,
	},
	autocompleteBox: {
		width: 233,
		maxHeight: 304,
		overflowY: 'auto',
		overflowX: 'hidden',
		...CssSelectors.allChildren(
			{
				...CssSelectors.allChildren(
					{
						...CssSelectors.allChildren(
							{
								padding: '5px 10px',
							},
							'div'
						),
					},
					'div'
				),
				width: 205,
			},
			'div'
		),
	},
	chevron: {
		marginLeft: 2,
		marginRight: 6,
	},
	chevronFlip: {
		transform: 'rotate3d(0,0,1,180deg)',
	},
	chevronIcon: {
		transform: 'rotate3d(0,0,1,0deg)',
	},
	container: {},
	expander: {
		height: '100%',
		overflow: 'hidden',
		position: 'relative',
		width: 215,
	},
	lastCommunicationDateDropdown: {
		marginTop: 15,
	},
	moreButton: {
		paddingLeft: 0,
	},
	searchBox: {
		':nth-child(1n)': {
			boxSizing: 'border-box',
			margin: '5px 14px 0 0',
			padding: '3px 6px',
			...CssSelectors.allChildren(
				{
					fontSize: 12,
				},
				'input'
			),
			[BrowserMediaQueries.IE11]: {
				width: '72%',
			},
		},
	},
	searchIcon: {
		marginRight: 8,
		marginTop: 5,
	},
	tag: {
		':nth-child(1n)': {
			padding: '2px 6px 2px 0',
		},
	},
	sectionWrap: {
		borderBox: 'box-sizing',
		alignItems: 'center',
		display: 'flex',
		padding: 10,
		borderTop: border,
		borderBottom: border,
	},
	sectionTitle: {
		minWidth: 200,
		color: colors.primary.main,
		fontSize: 14,
		margin: 0,
	},
	sectionIcon: {
		marginRight: 8,
		height: 16,
		width: 16,
	},
	createTag: {
		display: 'block',
		padding: 10,
		fontSize: 14,
	},
	noMargin: {
		margin: 0,
	},
});
